import { render, staticRenderFns } from "./DiscountTypeField.vue?vue&type=template&id=7edc30ae&"
import script from "./DiscountTypeField.vue?vue&type=script&lang=js&"
export * from "./DiscountTypeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7edc30ae')) {
      api.createRecord('7edc30ae', component.options)
    } else {
      api.reload('7edc30ae', component.options)
    }
    module.hot.accept("./DiscountTypeField.vue?vue&type=template&id=7edc30ae&", function () {
      api.rerender('7edc30ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/components/fields/DiscountTypeField.vue"
export default component.exports